// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"931f8d2b","603":"36189609","732":"df38f09b","779":"d8897ef0","977":"e36329a8"}[chunkId] + ".chunk.js";
};